import React from 'react';
import { Row, Col, Card, Table} from 'reactstrap';
import CodeBlock from '../CodeBlock';

function CreditUsageSection() {
    return (
        <section id="creditusage">
            <Row>
                <Col>
                    <h3>Credit usage endpoint (/Usage/Quota) – Quota usage for the company</h3>
                    <p>
                        <code>GET</code> request to <code>/usage/quota</code> returns usage statistics for companies on a credit
                        contract only.
                    </p>
                    <p>
                        Returns <code>CompanyUsesCredit : false</code> for companies not on credit contracts.
                    </p>
                    <Card className="bg-dark text-white" body>
                        <h4>Curl Example</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`curl -X GET \\\n'https://recruiter.totaljobs.com/CandidateSearchApi/usage/quota' \\\n-H 'authorization: bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQ2FuZGlkYXRlIFNlYXJjaCBVc2VyIiwic2l0ZUlkIjoiNCIsInVuaXF1ZV9uYW1lIjoiMzM5MTc1YWQtMTEwNS00OWVkLTk3MzQtOTU0YzM5NzJjNTNjIiwiY2xpZW50SWQiOiIwMUQ0MzFCNy02REMwLTRERDEtQkYzMS0xRDQwNzlEMTI0QkEiLCJjbGllbnRVc2VySWQiOiJBIiwiaXNzIjoiUmVjcnVpdGVyIiwiYXVkIjoiYWxsIiwiZXhwIjoxNjE3MjcxODA3LCJuYmYiOjE2MTcyNzAwMDcsIlNzYVNlc3Npb25JZCI6ImNkODNjMTcyLThkZGUtNDEwNy1hNzRjLTY1NjlhMGU3YTQ2ZSJ9.gLBhEwpM5Ezh0PihC1ZCNdf4moZy2qNp1Y23NL_MYto' \\\n-H 'cache-control: no-cache'`}
                        </CodeBlock>
                        <h4>REQUEST HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`Authorization: bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQ2FuZGlkYXRlIFNlYXJjaCBVc2VyIiwic2l0ZUlkIjoiNCIsInVuaXF1ZV9uYW1lIjoiMzM5MTc1YWQtMTEwNS00OWVkLTk3MzQtOTU0YzM5NzJjNTNjIiwiY2xpZW50SWQiOiIwMUQ0MzFCNy02REMwLTRERDEtQkYzMS0xRDQwNzlEMTI0QkEiLCJjbGllbnRVc2VySWQiOiJBIiwiaXNzIjoiUmVjcnVpdGVyIiwiYXVkIjoiYWxsIiwiZXhwIjoxNjE3MjcxODA3LCJuYmYiOjE2MTcyNzAwMDcsIlNzYVNlc3Npb25JZCI6ImNkODNjMTcyLThkZGUtNDEwNy1hNzRjLTY1NjlhMGU3YTQ2ZSJ9.gLBhEwpM5Ezh0PihC1ZCNdf4moZy2qNp1Y23NL_MYto`}
                        </CodeBlock>
                        <h4>RESPONSE HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`content-type: application/json; charset=utf-8\nstatus: 200 OK`}
                        </CodeBlock>
                        <h4>RESPONSE BODY</h4>
                        <CodeBlock langauge="json" theme="dark">
                            {`{\n\t"CompanyUsesCredit": true,\n\t"CandidatesViewed": 51,\n\t"CandidatesRemaining": 60949,\n\t"QuotaRefreshDate": "23/04/2021 00:00:00"\n}`}
                        </CodeBlock>
                    </Card>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>CompanyUsesCredit</td>
                                <td>boolean</td>
                                <td>Is the company using credits to view candidate information.</td>
                            </tr>
                            <tr>
                                <td>CandidatesViewed</td>
                                <td>integer</td>
                                <td>Number of candidates viewed by a company.</td>
                            </tr>
                            <tr>
                                <td>CandidatesRemaining</td>
                                <td>integer</td>
                                <td>Number of credits a company has left.</td>
                            </tr>
                            <tr>
                                <td>QuotaRefreshDate</td>
                                <td>date</td>
                                <td>Date that quota is reset.</td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </section>
    )
}

export default CreditUsageSection
